import { NewPaymentMethods } from '@efex-components/payables/PaymentModal/types';
import { MovementType } from '../types/detailCard.type';

const MOVEMENT_TYPES: MovementType[] = [
  { id: NewPaymentMethods.schedule, label: 'trsfDtlScheduledTransfer' },
  { id: NewPaymentMethods.forward, label: 'trsfDtlForwardTransfer' },
  { id: NewPaymentMethods.bank, label: 'trsfDtlBankTransfer' },
  { id: NewPaymentMethods.balance, label: 'trsfDtlBalanceTransfer' },
];

/**
 * Formats a date string into a localized string representation
 * @param {string | null} [date] - The date string to format
 * @returns {string} The formatted date string or '---' if no date provided
 */
const formatDate = (date?: string | null): string => {
  if (!date) return '---';
  return new Date(date).toLocaleString();
};

/**
 * Masks a string value leaving only specified number of characters visible
 * @param {string | null} [value] - The string value to mask
 * @param {number} [visibleChars=2] - Number of characters to leave visible at the end
 * @returns {string} The masked string or '---' if no value provided
 */
const maskValue = (value?: string | null, visibleChars = 2): string => {
  if (!value) return '---';
  const str = String(value);
  if (str.length <= visibleChars) return '*'.repeat(str.length);
  return '*'.repeat(str.length - visibleChars) + str.slice(-visibleChars);
};

/**
 * Gets the label for a movement type based on its ID
 * @param {NewPaymentMethods} [paymentMethodId] - The ID of the payment method/movement type
 * @returns {string} The corresponding label or '---' if no match found
 */
const getMovementTypeLabel = (paymentMethodId?: NewPaymentMethods): string => {
  const movementType = MOVEMENT_TYPES.find(
    (type) => type.id === paymentMethodId
  );
  return movementType?.label || '---';
};

export { formatDate, maskValue, getMovementTypeLabel };
